import { Link } from "react-router-dom";
import { rootFixedColor } from "styles/theme";
import styled from 'styled-components';

const FooterContainer = styled.footer`
    background-color: ${rootFixedColor.rootBgColor};
    color: ${rootFixedColor.footerColor};
    padding-left: 8rem;
    min-width: calc(1024px + 8rem);
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    font-size: 12px;
    word-break: keep-all;
    container: footer-container / inline-size;
    section:last-of-type {
        width: 100%;
        padding: 0.5rem 1.25rem;
        text-align: right;
    }
`;
const FooterInfoContainer = styled.section`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0.5rem 1.25rem 0.5rem;
    gap: 0.5rem;
    border-bottom: 1px solid ${rootFixedColor.footerColor};
    margin-top: 0.5rem;
    .footer-button-wrap {
        display: flex;
        flex-direction: row;
        gap: 1rem;
        align-items: center;
    }
    .footer-menu-title {
        font-weight: 600;
        a {
            color: #898989;
            &:hover {
                color: #dfdfdf;
            }
        }
    }
    .link-blank {
        border: 1px solid #898989;
        border-radius: 0.25rem;
        padding: 0.25rem 0.5rem;
    }
    .footer-info-wrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.875rem;
        img {
            display: inline-block;
            width: 8.75rem;
            height: 1.25rem;
            object-fit: contain;
        }
        P {
            position: relative;
            &::after {
                content: "|";
                position: absolute;
                width: 1px;
                right: -0.43rem
            }
        }
    }
`;
function Footer() {
    return (
      <FooterContainer>
        <FooterInfoContainer>
          <div className="footer-button-wrap">
            {/* <p className="footer-menu-title">
              <Link to="" target="_blank">Terms Of Use</Link>
            </p>
            <p className="footer-menu-title">
              <Link to="" target="_blank">Privacy Policy</Link>
            </p>
            <p className="footer-menu-title">
              <Link to="" target="_blank">Customer Support</Link>
            </p>
            <p className="footer-menu-title">
              <Link to="" target="_blank">License</Link>
            </p> */}
            <p className="footer-menu-title link-blank">
              <Link to="https://www.anyang.go.kr" target="_blank">Anyang City Website</Link>
            </p>
            <p className="footer-menu-title link-blank">
              <Link to="https://focushns.com/" target="_blank">FOCUS AI Website</Link>
            </p>
          </div>
          <div className="footer-info-wrap">
            <img src="/image/FOCUSAI_Red_White.png" alt="logo" />
            <p>FOCUS-AI-Co.,-Ltd.</p>
            <p>CEO</p>
            <p>Address</p>
            <p>Customer Center</p>
          </div>
        </FooterInfoContainer>
        <section>
          <p>&copy; 2025 FOCUS AI. ALL RIGHT RESERVED.</p>
        </section>
      </FooterContainer>
    );
}

export default Footer;